import * as React from 'react';
import { styled } from '@mui/system';
import { ROUTES } from '../../constants';
import { CustomNavLink } from '../../components';

const Div = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: '10rem',
});

export const DefaultVariablesPage: React.FC = () => (
  <Div>
    <CustomNavLink to={ROUTES.CREATE_DEFAULT_VARIABLES} title="Create Default Variable" color="secondary" />
    <CustomNavLink to={ROUTES.UPDATE_DEFAULT_VARIABLES} title="Update Default Variable" color="secondary" />
  </Div>
);
